export default "icons-truck"